import fonts from 'styles/fonts';
import Link from 'widget/components/Link';
import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';
import { Theme } from 'widget/styles/themes';

type Props = {
  'data-test'?: string;
};

const RoundedLink = styled(Link)<Props>(({ theme }: { theme: Theme }) => ({
  '& span': {
    display: 'none',
  },
  '& svg': {
    display: 'inline-block',
    fill: 'currentColor',
    height: '1.4rem',
    position: 'relative',
    top: '0.8rem',
    width: '1.4rem',
  },
  background: 'transparent',
  border: `0.1rem solid ${theme.fontPrimary}`,
  borderRadius: '1.7rem',
  boxSizing: 'border-box',
  color: theme.fontPrimary,
  fontSize: fonts.size['14'],
  height: '3.2rem',
  lineHeight: fonts.lineHeight['14'],
  padding: 0,
  textAlign: 'center',
  width: '3.2rem',
  [mediaQueryBuilder(mediaQueries.min.width['420'])]: {
    '& span': {
      display: 'inline-block',
    },
    '& svg': {
      height: '1.2rem',
      top: '0.1rem',
      width: '1.2rem',
    },
    padding: '.8rem 1.4rem',
    width: 'auto',
  },
}));

export default RoundedLink;
